module.exports = __webpack_public_path__ + "static/img/last_msg.7c64688.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/last_msg.png
// module id = zd3P
// module chunks = 1 3